/*
 * Copyright (c) 2023-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DisplayIcon from "../Icons/DisplayIcon.jsx";

class EmptyState extends Component {
    render() {
        return (
            <div
                className="max-w-full w-full h-full flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                <div className="space-y-1 text-center">
                    <DisplayIcon iconName={this.props.iconName} className={"mx-auto h-12 w-12 text-gray-400"}/>
                    {/*<IoTelescopeOutline className="mx-auto h-12 w-12 text-gray-400"/>*/}
                    <div className="flex text-sm text-gray-600">
                        <div className="pl-1">{this.props.text} </div>
                    </div>
                </div>
            </div>
        );
    }
}

EmptyState.propTypes = {
    text: PropTypes.any,
    iconName: PropTypes.string
};
EmptyState.defaultProps = {
    iconName: "IoTelescopeOutline"

}

export default EmptyState;